import { Component, OnInit, AfterViewInit } from '@angular/core';

import {
  MapCircle,
  MapComponent,
  MapPolygon,
} from 'movisat-maps';

import { AppComponent } from 'src/app/app.component';
import { CustomForms } from '../../forms/custom-forms';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { ConfigService } from 'src/app/services/config/config.service';

import { CasaModel } from 'src/app/services/geographics/casa.model';
import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { TicketModel } from 'src/app/services/sso/models/ticket.model';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

export enum TipoGeo {
  CIRCULO = 0,
  POLIGONO = 1,
}
@Component({
  selector: 'app-map-toolbar',
  templateUrl: './map-toolbar.component.html',
  styleUrls: ['./map-toolbar.component.css'],
})
export class MapToolbarComponent extends CustomForms implements OnInit, AfterViewInit {
  private _this: MapToolbarComponent;

  //maps
  private circle: MapCircle;
  private polygon: MapPolygon;
  public zona: ZonaModel = new ZonaModel();
  private zonaSelec: ZonaModel;
  public superficie = '0';
  public geometria = 'Circulo';

  //buttons
  public hiddenButton = true;
  public clickTools = false;
  public selectedToolIcon = '';
  private map: MapComponent;

  //styles and design
  public positionForm = 'center';
  public valueGroup = '';
  public environment = environment;
  //sso
  public ticketSSO: TicketModel;

  public constructor(
    private configService: ConfigService,
    private zonesService: ZonesService
  ) {
    super();
    this._this = this;
  }

  public ngOnInit(): void {
    this.ticketSSO = JSON.parse(localStorage.getItem('ticketSSO'));
  }

  public ngAfterViewInit(): void {
    this.setMargin();
    this.getMap();
  }

  //se activa cuando se presiona algún botón del grupo de botones
  public toggleChange(event: MatButtonToggleChange): void {
    const toggle = event.source;
    let optionSelected;
    if (toggle) {
      const group = toggle.buttonToggleGroup;
      if (event.value.some((item) => item == toggle.value)) {
        group.value = [toggle.value];
        this.selectedToolIcon = group.value;
        optionSelected = group.value;

        if (optionSelected == 'home') {
          this.selectedToolIcon = '';
          toggle.checked = false;
        }
      } else {
        this.selectedToolIcon = '';
        optionSelected = [];
      }
      this.onSelectOption(optionSelected);
    }
  }

  //cuando se hace click sobre button tools
  public onClickTools(): void {
    this.hiddenButton = this.hiddenButton ? false : true;
  }

  //filtra el botón seleccionado del button group
  public onSelectOption(optionSelected: string[]): void {
    this.onClickTools();
    switch (optionSelected[0]) {
      case 'home':
        this.onSelectHome();
        break;
    }
  }

  //gestiona el dibujo de la casa
  public async onSelectHome(): Promise<void> {
    const res = await this.configService.getEmpApp('casa', null);
    if (res) {
      const casa: CasaModel = JSON.parse(res);
      MainComponent.getActiveMap().setZoom(casa.zoom);
      MainComponent.getActiveMap().setCenter(casa.posicion);
    }
  }

  //traigo mapa del componente principal
  public getMap(): void {
    setTimeout(() => {
      this.map = MainComponent.getActiveMap();
      Promise.resolve(1);
    }, 1000);
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  //cambia margen derecho según cartografía
  public setMargin(): void {
    const toolbar = document.getElementById('toolbar');
    if (toolbar && this.ticketSSO?.Empresa?.Cartografia === 'Google') {
      toolbar.style.right = '10px';
    }
  }
}
